<template>
  <div id="submissions-page">
    <div class="flex-grow my-4">
      <h1>{{ $t('Commissions') }}</h1>
    </div>

    <div class="vx-card full-page">
      <grid-panel
        v-if="!loading"
        :column-defs="columnDefs"
        :url="url"
        autoSize
      >
        <template slot="left">
          <h3>{{ $t('CommissionsOnTaxablePremiumIncludingAccessories') }}</h3>
        </template>
      </grid-panel>
    </div>
  </div>
</template>

<script>
import GridPanel from '@/views/components/ag-grid/GridPanel';
import GridActionsMenu from "../../components/extra-components/GridActionsMenu";
import CommissionsConfig from '@/grids/Commissions/CommissionsConfig';
import DateRangePicker from "../../components/calendar/DateRangePicker";
import CellRendererDate from "../../components/ag-grid/cell-renderer/CellRendererDate";
import CellRendererDownload from "../../components/ag-grid/cell-renderer/CellRendererDownload";
import CellRendererCurrency from "../../components/ag-grid/cell-renderer/CellRendererCurrency";
// import SetGridOptionsMixin from "@/components/mixins/SetGridOptionsMixin";

export default {
  components: {
    GridPanel,
    GridActionsMenu,
    DateRangePicker,
    CellRendererDate,
    CellRendererDownload,
    CellRendererCurrency,
  },
  // mixins: [SetGridOptionsMixin],
  data() {
    return {
      columnDefs: CommissionsConfig,
      url: () => this.$api.producerCommissions.list(),
      loading: false,
    };
  },
};
</script>
